import React from 'react';
import {
  Link,
  InlineTextLink,
} from '../../../coreui';

const AccredGTKYNotSubmitted = () => {
  return (
    <>
      Due to applicable regulations, in order to see all investment
      opportunities you need to complete our full investor questionnaire.{' '}
      {
        <InlineTextLink to="/getting-to-know-you">
          {' '}
          Click here{' '}
        </InlineTextLink>
      }
      to complete the questions. Or call us at:
      <Link type="L4" href="tel:18777817062">
        {' '}
        (877) 781-7062
      </Link>
    </>
  );
};

export default AccredGTKYNotSubmitted;
